// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"BodyText_bodyText__rPWZl","truncate":"BodyText_truncate__XKDCD"};